import { Component, OnInit } from '@angular/core';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaRepair',
  templateUrl: './DeviceBehfaRepair.component.html',
  styleUrls: ['./DeviceBehfaRepair.component.scss']
})
export class DeviceBehfaRepairComponent implements OnInit {

  Token:String=""
  View_Partition:string="List"
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DeviceBehfa_Service:DeviceBehfaService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Data_Seleted_DeviceBehfa:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1127).subscribe(
      data=>{
        this.ReadData_DeviceBehfa()
      }

    )


  }



  ReadData_DeviceBehfa(){
    this.Procssing=true
    this.DeviceBehfa_Service.GetRepair(this.Token).subscribe(
      data=>{
        this.DataList_DeviceBehfa=data
        this.Procssing=false
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Set_View_Partition(item:string)
  {
    this.Data_Seleted_DeviceBehfa=Empty_DeviceBehfa_Interface()
    this.View_Partition=item
  }


  Set_DeviceBehfa_Record(item:DeviceBehfa_Interface)
  {
    this.View_Partition='Form'
    this.Data_Seleted_DeviceBehfa=item
  }

  OnSet_Back_ShowList(item:any)
  {
    this.View_Partition='List'
  }


}
